import type Icon from '@ant-design/icons/lib/components/Icon';
import { Button } from 'antd';
import { useNavigate } from 'react-router';
import type { TComponent } from 'utils/types/component';

import styles from './EmptyPage.module.scss';

interface IEmptyPageProps {
    text: string;
    icon: typeof Icon;
    actionHref?: string;
    actionText?: string;
}

const EmptyPage: TComponent<IEmptyPageProps> = (props) => {
    const { actionHref, text, actionText, icon: IconComponent } = props;

    const navigate = useNavigate();

    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>
                <IconComponent className={styles.icon} />
                <span className={styles.text}>{text}</span>
                {actionHref && (
                    <Button
                        className={styles.btn}
                        type='primary'
                        onClick={() => navigate(actionHref)}
                    >
                        {actionText}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default EmptyPage;
